// imports
import Component from 'minsky-kit/js/components/Component';
import { createApp } from 'vue';
import FloatingVue from 'floating-vue';
import Icon from '../components/Icon/Icon.vue';

// private statics
import SearchWidget from '../components/SearchWidget/SearchWidget.vue';

// class definition
export default class SearchWidgetApp extends Component {
    // constructor
    constructor (args = {}, objectName = 'SearchWidgetApp') {
        // super
        super(args, objectName);

        this.app = createApp(SearchWidget, {
            type: args.type ? args.type : 'default',
        });

        if (args.drupal) {
            this.app.config.globalProperties.Drupal = args.drupal;
        }

        this.app.use(FloatingVue, {
            themes: {
                'search-widget': {
                    distance:        0,
                    triggers:        [],
                    autoHide:        false,
                    placement:       'bottom-start',
                    preventOverflow: false,
                    autoSize:        true,
                },
            },
        });

        this.app.component('Icon', Icon);
        this.searchWidget = this.app.mount(args.$el);
    }

    // methods
    destroy () {
        // super destroy
        super.destroy();
    }

    clear () {
        this.searchWidget.clear();
    }

    // getters & setters
}

// Utils

// Event handlers
